module.exports = __webpack_public_path__ + "img/cerrarB.b4e49ccc.png";